import { render, staticRenderFns } from "./phoneSale.vue?vue&type=template&id=6275a896&scoped=true&"
import script from "./phoneSale.vue?vue&type=script&lang=ts&"
export * from "./phoneSale.vue?vue&type=script&lang=ts&"
import style0 from "./phoneSale.vue?vue&type=style&index=0&id=6275a896&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6275a896",
  null
  
)

export default component.exports